import { IUpdatePromotionDTO, PromotionStatus, PromotionTemplate } from '@/models/promotion.model';
import { CouponFormFields, TCreateCouponFormValues } from '../helpers';

class UpdateCouponDTO implements IUpdatePromotionDTO {
  id: string;

  code?: string;

  dateFrom?: null | string;

  dateTo?: null | string;

  description?: string;

  minOrderAmount?: number;

  name?: string;

  rate?: number;

  status?: PromotionStatus;

  templateNumber?: PromotionTemplate;

  constructor(values: Partial<TCreateCouponFormValues> & { couponId: string }) {
    this.id = values.couponId;
    this.code = values[CouponFormFields.CODE];
    this.description = values[CouponFormFields.POPUP_DESCRIPTION];
    this.minOrderAmount = values[CouponFormFields.MIN_ORDER_AMOUNT];
    this.name = values[CouponFormFields.POPUP_TITLE];
    this.rate = Number(values[CouponFormFields.RATE]) || undefined;
    this.status = values[CouponFormFields.STATUS];
    this.templateNumber = values[CouponFormFields.TEMPLATE];

    const dateFrom = values[CouponFormFields.DATE_FROM];
    this.dateFrom = dateFrom === null ? null : dateFrom?.toISOString();
    const dateTo = values[CouponFormFields.DATE_TO];
    this.dateTo = dateTo === null ? null : dateTo?.toISOString();
  }
}

export default UpdateCouponDTO;
